import { render, staticRenderFns } from "./FamousPediaReadWeb.vue?vue&type=template&id=8e83fe46&"
import script from "./FamousPediaReadWeb.vue?vue&type=script&lang=js&"
export * from "./FamousPediaReadWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports